import React from 'react'

export type ShowIfProps = {
  condition?: boolean
  isDefault?: boolean
  children: React.ReactNode
}

export const ShowIf = ({ children }: ShowIfProps) => <>{children}</>
